module.exports = __webpack_public_path__ + "images/square_bordered.png";